import React, { useState, useEffect } from "react";
import "./StartForm.css"; 
import { useNavigate } from "react-router-dom";

export default function TractumStartPage() {
  const navigate = useNavigate();
  const [activeProduct, setActiveProduct] = useState(null);

  const products = [
    { title: "ZeregBeam", text: "Semantic data modules for everything.", price: "Free" },
    { title: "ZeregField", text: "Declarative cross-platform querying.", price: "€9 / month" },
    { title: "ZeregDoc", text: "Manage sheets, metadata, and workflows.", price: "€15 / month" },
    { title: "ZeregSync", text: "Sync containers across devices.", price: "€7 / month" },
    { title: "Tractum Developer Kit", text: "Build custom modules with semantic YAML.", price: "Free" },
    { title: "Automation Engine", text: "Create cross-app automation pipelines.", price: "€12 / month" },
    { title: "ZeregDesk", text: "Desk and space booking system.", price: "€5 / month" },
    { title: "Templates Library", text: "Prebuilt templates for apps and workflows.", price: "€3 / month" },
    { title: "YAML Playground", text: "Interactive YAML testing and building.", price: "Free" },
    { title: "API Docs", text: "Developer API documentation.", price: "Free" },
  ];

  useEffect(() => {
    const token = localStorage.getItem("jwt_access_token");
    const tenantCode = localStorage.getItem("tenant_code");
    const host = window.location.hostname; // e.g., hair.tractum.bimzereg.com
    const parts = host.split(".");

    // 1️⃣ Logged in + tenant subdomain → redirect to tenants dashboard
    if (token && tenantCode && host.startsWith(`${tenantCode}.`)) {
      navigate("/tenants");
      return;
    }
    // Otherwise: show central landing page normally
  }, [navigate]);

  const handleRegister = (product) => setActiveProduct(product);
  const closeModal = () => setActiveProduct(null);

  return (
    <div className="page-container">
      {/* HERO SECTION */}
      <div className="hero">
        <h1 className="hero-title">Build. Connect. Automate.</h1>
        <p className="hero-sub">
          Zereg is the semantic engine for apps, workflows, and smart data containers.
        </p>
        <div className="hero-buttons">
          <button className="btn-primary">Get Started (Free)</button>
          <button className="btn-outline">Documentation</button>
        </div>
      </div>

      {/* PRODUCT CARDS */}
      <div className="grid">
        {products.map((p, i) => (
          <ProductCard key={i} {...p} onRegister={() => handleRegister(p.title)} />
        ))}
      </div>

      {/* Developer Section */}
      <SectionTitle title="For Developers" />
      <div className="grid-small">
        <MiniCard title="API Docs" />
        <MiniCard title="YAML Playground" />
        <MiniCard title="Examples & Templates" />
      </div>

      {/* User Section */}
      <SectionTitle title="For Users" />
      <div className="grid-small">
        <MiniCard title="Install App" />
        <MiniCard title="Tractum Sheets" />
        <MiniCard title="Templates Library" />
      </div>

      {/* Registration Modal */}
      {activeProduct && <RegisterModal product={activeProduct} onClose={closeModal} />}
    </div>
  );
}

/* --------------------- Child Components --------------------- */

function ProductCard({ title, text, price, onRegister }) {
  return (
    <div className="card">
      <div className="card-content">
        <h3 className="card-title">{title}</h3>
        <p className="card-text">{text}</p>
        <p className="card-price">{price}</p>
      </div>
      <button className="btn-register" onClick={onRegister}>Register</button>
    </div>
  );
}

function MiniCard({ title }) { return <div className="mini-card">{title}</div>; }
function SectionTitle({ title }) { return <h2 className="section-title">{title}</h2>; }

function RegisterModal({ product, onClose }) {
  const [form, setForm] = React.useState({ tenant: "", email: "", password: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    await fetch("/api/register", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...form, product }),
    });
    alert(`Tenant created successfully for ${product}!`);
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>Register for {product}</h2>
        <form onSubmit={handleSubmit}>
          <input type="text" placeholder="Tenant / Company Name" value={form.tenant} onChange={e => setForm({ ...form, tenant: e.target.value })} required />
          <input type="email" placeholder="Admin Email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required />
          <input type="password" placeholder="Password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required />
          <div className="modal-buttons">
            <button type="submit">Submit</button>
            <button type="button" onClick={onClose}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
}
